import {
  INVOICE_SUB_AGENT_CREATE_FAIL,
  INVOICE_SUB_AGENT_CREATE_REQUEST,
  INVOICE_SUB_AGENT_CREATE_SUCCESS,
  INVOICE_SUB_AGENT_DELETE_FAIL,
  INVOICE_SUB_AGENT_DELETE_REQUEST,
  INVOICE_SUB_AGENT_DELETE_SUCCESS,
  INVOICE_SUB_AGENT_GET_FAIL,
  INVOICE_SUB_AGENT_GET_REQUEST,
  INVOICE_SUB_AGENT_GET_SUCCESS,
  INVOICE_SUB_AGENT_LIST_FAIL,
  INVOICE_SUB_AGENT_LIST_REQUEST,
  INVOICE_SUB_AGENT_LIST_SUCCESS,
  INVOICE_SUB_AGENT_UPDATE_FAIL,
  INVOICE_SUB_AGENT_UPDATE_REQUEST,
  INVOICE_SUB_AGENT_UPDATE_SUCCESS,
} from "../constants/invoiceSubAgentConstants";
import api from "../core/api";

export const listSubAgentInvoices =
  (invoiceFilter) => async (dispatch, getState) => {
    try {
      dispatch({
        type: INVOICE_SUB_AGENT_LIST_REQUEST,
      });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await api.post(
        "/accounts/subagentinvoice/getInvoices",
        invoiceFilter,
        config
      );

      var dt = data.Result;

      if (typeof dt === "string") {
        dispatch({
          type: INVOICE_SUB_AGENT_LIST_FAIL,
          payload: data.Result.replace("Error - ", ""),
        });
      } else {
        dispatch({
          type: INVOICE_SUB_AGENT_LIST_SUCCESS,
          payload: dt,
          total: data.totalInvoices
        });
      }
    } catch (error) {
      dispatch({
        type: INVOICE_SUB_AGENT_LIST_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const createSubAgentInvoices =
  (subagentInvoiceJson) => async (dispatch, getState) => {
    try {
      dispatch({
        type: INVOICE_SUB_AGENT_CREATE_REQUEST,
      });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await api.post(
        "/accounts/subagentinvoice",
        subagentInvoiceJson,
        config
      );

      var dt = data.Result;

      if (dt.includes("error")) {
        dispatch({
          type: INVOICE_SUB_AGENT_CREATE_FAIL,
          payload: data.Result.replace("Error - ", ""),
        });
      } else {
        dispatch({
          type: INVOICE_SUB_AGENT_CREATE_SUCCESS,
          payload: dt,
        });
      }
    } catch (error) {
      dispatch({
        type: INVOICE_SUB_AGENT_CREATE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const getSubAgentInvoices =
  (invoiceId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: INVOICE_SUB_AGENT_GET_REQUEST,
      });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await api.get(
        "/accounts/subagentinvoice/" + invoiceId,
        config
      );

      var dt = data.Result;

      if (typeof dt === "string") {
        dispatch({
          type: INVOICE_SUB_AGENT_GET_FAIL,
          payload: data.Result.replace("Error - ", ""),
        });
      } else {
        dispatch({
          type: INVOICE_SUB_AGENT_GET_SUCCESS,
          payload: dt,
        });
      }
    } catch (error) {
      dispatch({
        type: INVOICE_SUB_AGENT_GET_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const updateSubAgentInvoice =
  (invoiceId, subagentinvoicejson) => async (dispatch, getState) => {
    try {
      dispatch({
        type: INVOICE_SUB_AGENT_UPDATE_REQUEST,
      });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await api.put(
        "/accounts/subagentinvoice/" + invoiceId,
        subagentinvoicejson,
        config
      );

      var dt = data.Result;

      if (dt.includes("Error")) {
        dispatch({
          type: INVOICE_SUB_AGENT_UPDATE_FAIL,
          payload: data.Result.replace("Error - ", ""),
        });
      } else {
        dispatch({
          type: INVOICE_SUB_AGENT_UPDATE_SUCCESS,
          payload: dt,
        });
      }
    } catch (error) {
      dispatch({
        type: INVOICE_SUB_AGENT_UPDATE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const deleteSubAgentInvoice =
  (invoiceId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: INVOICE_SUB_AGENT_DELETE_REQUEST,
      });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await api.delete(
        "/accounts/subagentinvoice/" + invoiceId,
        config
      );

      var dt = data.Result;

      if (dt.includes("Error")) {
        dispatch({
          type: INVOICE_SUB_AGENT_DELETE_FAIL,
          payload: data.Result.replace("Error - ", ""),
        });
      } else {
        dispatch({
          type: INVOICE_SUB_AGENT_DELETE_SUCCESS,
          payload: dt,
        });
      }
    } catch (error) {
      dispatch({
        type: INVOICE_SUB_AGENT_DELETE_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };
